import React from "react";
import { Surface } from "../../../atoms/Surface";
import { HiInformationCircle } from "react-icons/hi";
import { useTranslation } from "react-i18next";
import { CustomButton } from "../../../atoms/CustomButton";

interface ErrorStateProps {
  onRetry: () => void;
}

export const ErrorState: React.FC<ErrorStateProps> = ({ onRetry }) => {
  const { t } = useTranslation("clientView");

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 p-4">
      <Surface className="max-w-md w-full">
        <div className="text-center">
          <HiInformationCircle className="mx-auto h-16 w-16 text-red-500" />
          <h2 className="mt-4 text-xl font-semibold text-gray-900">
            {t("customRegistration.page.error.title")}
          </h2>
          <p className="mt-2 text-gray-600">
            {t("customRegistration.page.error.message")}
          </p>
          <CustomButton
            variant="primary"
            onClick={onRetry}
            title={t("customRegistration.page.error.retryButton")}
            className="mt-6 mx-auto"
          />
        </div>
      </Surface>
    </div>
  );
};
